import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from './AuthContext';
import { verifyStatus } from './api_v1_jt';
import { useNavigate } from 'react-router-dom';

const ProtectedRoutes = ({ element: Component, requireAuth = true, ...rest }) => {
    const { auth, fetchNewRefreshToken } = useContext(AuthContext);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const handleAuth = async () => {
            const urlParams = new URLSearchParams(window.location.search);
            const msisdn = urlParams.get('a');
            const refferer = urlParams.get('referer') || urlParams.get('refferer');
            const r = urlParams.get('r')
            
            if (refferer) {
                sessionStorage.setItem("refferer", refferer);
            }

            const storedrefferer = sessionStorage.getItem("refferer") || urlParams.get('referer') || urlParams.get('refferer');

            if (!sessionStorage.getItem("firstLoad")) {
                localStorage.clear();  // Clear local storage on first app load
                sessionStorage.setItem("firstLoad", "true");
            }

            if (auth.accessToken) {
                setLoading(false);
                return;
            }

            if (msisdn) {
                try {
                    const loginStatus = await verifyStatus(msisdn);
                    const status = loginStatus?.data?.data?.status;
                    const refferer = sessionStorage.getItem("refferer") || urlParams.get('referer') || urlParams.get('refferer');
                    if (status === 1 || status === 2) {
                        const newAuth = await fetchNewRefreshToken(msisdn, refferer);
                        if (newAuth) {
                            if(r === '1') {
                                navigate('/puzzle');
                                return;
                            }
                            setLoading(false);
                            if (requireAuth) {
                                window.history.replaceState({}, '', window.location.pathname);
                                window.location.reload();
                            } else {
                                navigate(window.location.pathname, { replace: true });
                            }
                            return;
                        }
                    } else if (requireAuth && !['z_esg', 'u_esg'].includes(storedrefferer)) {
                        console.log("REDIRE ");
                        window.location.href = process.env.REACT_APP_LOGIN_URL;
                        return;
                    }
                } catch (error) {
                    console.error("Error verifying status:", error);
                }
            }

            if (!requireAuth) {
                setLoading(false);
                return;
            }

            if (storedrefferer === 'u_esg' || storedrefferer === 'z_esg') {
                setLoading(false);
                return;
            }

            window.location.href = process.env.REACT_APP_LOGIN_URL;
        };

        handleAuth();
    }, [auth.accessToken, fetchNewRefreshToken, requireAuth]);

    if (loading) {
        return <div>Loading...</div>;
    }

    return (!requireAuth || auth.accessToken) ? <Component {...rest} /> : null;
};

export default ProtectedRoutes;
